import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

export interface IWarningModalProps {
  open: boolean;
  handleClose: () => void;
  text: string;
}

export function WarningModal(props: IWarningModalProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.text}</DialogTitle>
      <DialogActions>
        <Button onClick={props.handleClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
